var normalizeComponent = require("!../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d694245fa2f13794fad64f98c4d748e3/node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = null
/* template */
import __vue_template__ from "!!../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d694245fa2f13794fad64f98c4d748e3/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4e37de68\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d694245fa2f13794fad64f98c4d748e3/node_modules/vue-loader/lib/selector?type=template&index=0!./RealApp.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/RealApp.vue
// module id = 101
// module chunks = 1